import React, { useContext, useEffect, useState } from "react";
import { Context } from "../../../context/context";
import moment from "moment";
import DateRangePicker from "@wojtekmaj/react-daterange-picker/dist/DateRangePicker";

import "./VolumeEmpresa.scss";
import { Button } from "@mui/material";
import LineChart from "../../../components/LineChart/LineChart";
import { getVolumeByCompany } from "../../../services/graphics-service";
import { formatGraphicVolumePerCompany } from "../../../utils/formatted-graphic-values";

const VolumeEmpresa = () => {
  const { sidebar } = useContext(Context);
  const token = localStorage.getItem("token");
  const [graphicValues, setGraphicValues] = useState({});
  const [showGraphic, setShowGraphic] = useState(false);
  const [dateValue, setDateValue] = useState([
    moment(new Date()).subtract(30, "day").toDate(),
    new Date(),
  ]);

  const getGraphicData = async () => {
    const result = await getVolumeByCompany(token, dateValue[0], dateValue[1]);

    setGraphicValues(formatGraphicVolumePerCompany(result.data.companies));

    setShowGraphic(true);
  };

  return (
    <main className={sidebar ? "container" : "container-full"}>
      <h1>Volume perdido por empresa</h1>

      <div className="graphic-csv-container">
        <p>Favor escolher as empresas para gerar o gráfico</p>

        <DateRangePicker onChange={(e) => setDateValue(e)} value={dateValue} />

        <div>
          <Button
            className="generate-btn"
            variant="contained"
            onClick={getGraphicData}
          >
            Gerar gráfico
          </Button>
        </div>

        {showGraphic && (
          <>
            <br />
            <p>
              Caso nenhum resultado seja encontrado, possivelmente não existe
              nenhuma venda perdida para este período.
            </p>
          </>
        )}
      </div>

      {showGraphic && (
        <div className="graphic-container">
          <LineChart values={graphicValues} />
        </div>
      )}
    </main>
  );
};

export default VolumeEmpresa;
